// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3shvP","right":"Footer_right__3LJgf","buttons":"Footer_buttons__IMf-1"};